module.exports = {
    data () {
        return {
            windowWidth: 0,
            currentTailwindBreakpoint: 0,
            notSmallScreen: false
        };
    },

    computed: {
        /**
         * Access the global App object.
         */
        app () {
            return window.App;
        },

        state () {
            return this.app.state;
        },

        idealNormalDialogSize () {
            if (this.windowWidth < 480) {
                return (this.windowWidth * 0.9) + "px";
            }

            if (this.windowWidth <= 700) {
                return "500px";
            }

            if (this.windowWidth <= 900) {
                return "600px";
            }

            return "700px";
        },
    },

    watch: {
        windowWidth: function (newWidth) {
            this.notSmallScreen = newWidth >= 768;
            this.currentTailwindBreakpoint = this.getCurrentTailwindBreakpoint();
        }
    },

    mounted () {
        this.getWindowWidth();

        this.$nextTick(function () {
            window.addEventListener("resize", this.getWindowWidth);
            window.addEventListener("resize", this.getWindowHeight);
        });

        if (this.app.state.user.email) {
            if (window.Sentry) {
                window.Sentry.configureScope((scope) => {
                    scope.setUser({"email": this.app.state.user.email});
                    scope.setExtra("team", this.app.state.currentTeam.trading_name);
                });
            }
        }
    },

    methods: {
        getCurrentTailwindBreakpoint () {
            if (this.windowWidth < 640) {
                return 0;
            }

            if (this.windowWidth < 768) {
                return 1;
            }

            if (this.windowWidth < 1024) {
                return 2;
            }

            return 3;
        },

        currentBrowser () {
            let userAgent = navigator.userAgent;
            let browserName;
            if (userAgent.match(/chrome|chromium|crios/i)) {
                browserName = "chrome";
            } else if (userAgent.match(/firefox|fxios/i)) {
                browserName = "firefox";
            } else if (userAgent.match(/safari/i)) {
                browserName = "safari";
            } else if (userAgent.match(/opr\//i)) {
                browserName = "opera";
            } else if (userAgent.match(/edg/i)) {
                browserName = "edge";
            } else {
                browserName = "No browser detection";
            }

            return browserName;
        },

        shouldSeeTrialView () {
            return this.state.show_trial_pages;
        },

        getWindowWidth (event) {
            this.windowWidth = document.documentElement.clientWidth;
            this.currentTailwindBreakpoint = this.getCurrentTailwindBreakpoint();
        },

        /**
         * Check if the user has a permission
         */
        userCan (permission) {
            return this.app.state.permissions.indexOf(permission) !== -1;
        },

        userCanManageCompanySettings () {
            return this.userCan("manage-company-details") ||
                this.userCan("manage-billing") ||
                this.userCan("manage-users") ||
                this.userCan("manage-portfolios") ||
                this.userCan("manage-mailboxes");
        },

        userHasRole (role) {
            return this.app.state.user.role === role;
        },

        userIsSupport () {
            return this.app.state.is_support || this.app.state.user.support;
        },

        teamIsActive () {
            return this.app.state.currentTeam ? this.app.state.currentTeam.subscription_status === "active" : false;
        },

        currentPricingPlanIs (pricingPlanName) {
            return this.app.state.currentTeam?.subscription?.pricing_plan === pricingPlanName;
        },

        verifyTeamIsSubscribed () {
            if (this.teamIsActive()) {
                return true;
            }

            swal({
                title: "You're not signed up",
                text: "Complete your subscription to start using RedRabbit!",
                showCancelButton: true,
                cancelButtonText: "Close",
                confirmButtonText: "Let's do it now"
            }).then((result) => {
                if (result.value) {
                    window.location.href = "/settings#/tab-billing";
                }
            });

            return false;
        },

        hasFeature (key) {
            let featureFlag = this.getFeature(key);
            return featureFlag && featureFlag.available && featureFlag.enabled;
        },

        featureIsEnabled (key) {
            return this.getFeature(key) && this.getFeature(key).enabled === true;
        },

        featureIsAvailable (key) {
            return this.getFeature(key) && this.getFeature(key).available === true;
        },

        getFeature (featureKey) {
            return this.app.state.featureFlags.find(({key}) => key === featureKey);
        },

        userHasMailbox () {
            return this.app.state.user.mailboxes.length > 0;
        },

        smallScreen () {
            return this.notSmallScreen === false;
        },

        validateEmail (email) {
            let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
    },

    beforeDestroy () {
        window.removeEventListener("resize", this.getWindowWidth);
    }
};
